// extracted by mini-css-extract-plugin
module.exports = {"poster":"poster___2JOTp"};